import { ReactNode } from 'react'

import { InlineLink } from '@scouts/ui'

import { track, TRACK_BANKING_BBVA_CTA_CLICK } from '@/trackers'

export const BankingPromotionLink = ({ children }: { children: ReactNode }) => {
    const handleClick = () => {
        track(TRACK_BANKING_BBVA_CTA_CLICK)
    }

    return (
        <InlineLink
            onClick={handleClick}
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.bbva.es/general/landings/empresas/cuentas/cuenta-negocios-bienvenida-autonomos.html?cid=ref::tax:00006740-taxscouts_2023--:--::::::::"
        >
            {children}
        </InlineLink>
    )
}
